import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/atoms';
import { CategoryCreateForm } from './category-create-form';

export const CREATE_CATEGORY_VALUE = '__create_category__';

interface CategoryModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSuccess?: (result: { categoryId: number; subcategoryId: number }) => void;
}

export const CategoryModal = ({
  open,
  onOpenChange,
  onSuccess,
}: CategoryModalProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Create category</DialogTitle>
          <DialogDescription>
            Add a category and one or more subcategories for your products.
          </DialogDescription>
        </DialogHeader>

        <CategoryCreateForm
          onCancel={() => onOpenChange(false)}
          onSuccess={(result) => {
            onSuccess?.(result);
            onOpenChange(false);
          }}
        />
      </DialogContent>
    </Dialog>
  );
};
